import React from "react";
import { FaUsers, FaTimesCircle } from "react-icons/fa";

const EmployeeModal = ({ isOpen, onClose, employees }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
  <div className="bg-white p-6 rounded-2xl shadow-2xl w-[90vw] max-w-[800px] overflow-auto max-h-[90vh]">
    <h2 className="text-2xl font-bold text-center mb-6 text-blue-700 flex items-center justify-center gap-2">
      <FaUsers /> Daftar Karyawan
    </h2>

    {/* Tabel Employee */}
    <div className="overflow-auto max-w-full rounded-xl border border-gray-200 shadow-inner">
      <table className="w-full border-collapse text-sm text-gray-800 min-w-max">
        <thead className="bg-gray-100 sticky top-0 z-10">
          <tr>
            <th className="border p-3 text-left font-semibold">Nama</th>
            <th className="border p-3 text-left font-semibold">Posisi</th>
            <th className="border p-3 text-left font-semibold">Alamat</th>
          </tr>
        </thead>
        <tbody>
          {employees?.length > 0 ? (
            employees.map((employee) => (
              <tr key={employee.id} className="hover:bg-gray-50 transition-colors">
                <td className="border p-3">{employee.full_name}</td>
                <td className="border p-3 capitalize">{employee.role}</td>
                <td className="border p-3">{employee.alamat}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="border p-4 text-center text-gray-500">
                Tidak ada karyawan
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* Tombol Close */}
    <button
      onClick={onClose}
      className="w-full mt-6 bg-gray-500 text-white py-3 rounded-lg hover:bg-gray-600 font-medium flex items-center justify-center gap-2 transition-all"
    >
      <FaTimesCircle /> Tutup
    </button>
  </div>
</div>
  );
};

export default EmployeeModal;
